import mitt from 'mitt'

export type AuthEvents = {
	'login.success'?: never
	'register.success'?: never
}

export const authEmitter = mitt<AuthEvents>()
